export enum YesNoUnknown {
  Unknown = "Unknown",
  Yes = "Yes",
  No = "No",
}
